import React from "react";
import PartyPage from "@/pages/sales/PartyPage";
export default function Customers() { return <PartyPage kind="customer" />; }
